import React from 'react';
import { NumericFormat } from 'react-number-format';

  const PercentageNumberFormat = React.forwardRef(function PercentageNumberFormat(props, ref) {

  const { onChange, allowNegative, maxValue, minValue, ...other } = props;
  let minVal = minValue;
  if (minVal == null) {
    minVal = 0;
  }
  let maxVal = maxValue;
  if (maxVal == null) {
      maxVal = 100;
  }

  return (
    <NumericFormat
      {...other}
      allowNegative={(allowNegative) ? true: false}
      getInputRef={ ref }
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          }
        })
      }}
      isAllowed={(values) => {

        const {floatValue, value} = values;

        //don't allow leading zeros, doesn't make sense
        //we commented this out to not allow leading zeros 
        /*if (value.startsWith('0')) {
          return false;
        }*/

        return floatValue >=  minVal && floatValue <= maxVal;
      }}
      valueIsNumericString
      decimalScale={2}
      fixedDecimalScale
      suffix="%"
    />
  );
});

export default PercentageNumberFormat;
